import BraceOrderDetails from './BraceOrderDetails';

export default BraceOrderDetails;
